var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_688_5934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8108 32C8.59056 32 6.73106 30.2955 6.5083 28.0561L4.1098 6.99299H1.4965C0.670004 6.99299 0 6.32299 0 5.4965C0 4.67 0.670004 4 1.4965 4H10.8108V2.63026C10.8108 1.17761 11.9725 0 13.4054 0H19.4595C20.8924 0 22.0541 1.17761 22.0541 2.63026V4H30.5035C31.33 4 32 4.67 32 5.4965C32 6.32299 31.33 6.99299 30.5035 6.99299H27.8902L25.4917 28.0561C25.2689 30.2955 23.4094 32 21.1892 32H10.8108ZM7.84039 6.99299C7.2424 6.99299 6.77809 7.51434 6.84706 8.10834L9.08981 27.4224C9.17891 28.3182 9.92271 29 10.8108 29H21.1892C22.0773 29 22.8211 28.3182 22.9102 27.4224L25.1529 8.10834C25.2219 7.51434 24.7576 6.99299 24.1596 6.99299H7.84039Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_688_5934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.7ffc1b827143d2f3aab74152acbe6e23.svg";
export { ForwardRef as ReactComponent };